import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

import { environment } from "src/environments/environment";

@Injectable()
export class RegistrationEnvironmentGuard implements CanActivate {

    constructor(
        private router: Router
    ) { }

    public canActivate(): boolean {
        if (!["CTT", "KZ"].includes(environment.project)) {
            this.router.navigate(["user/login"]);
            return false;
        } else {
            return true;
        }
    }
}
